import { createAction } from 'redux-actions';

export const DASHBOARD_UPSELL_ACTIONS_TYPES = {
  storageUpsellModal: {
    triggered: '[Dashboard Storage Upsell Modal] triggered',
    closed: '[Dashboard Storage Upsell Modal] closed',
    upgradeButton: {
      clicked: '[Dashboard Storage Upsell Modal] upgrade button clicked',
    },
  },
};

export const dashboardUpsellActions = {
  storageUpsellModal: {
    triggered: createAction(
      DASHBOARD_UPSELL_ACTIONS_TYPES.storageUpsellModal.triggered
    ),
    closed: createAction(
      DASHBOARD_UPSELL_ACTIONS_TYPES.storageUpsellModal.closed
    ),
    upgradeButton: {
      clicked: createAction(
        DASHBOARD_UPSELL_ACTIONS_TYPES.storageUpsellModal.upgradeButton.clicked
      ),
    },
  },
};
